import {Component, Input} from '@angular/core';
import {BrLangWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-langwetter-bericht',
  templateUrl: './br-langwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrLangwetterBerichtComponent {
  @Input() langWetterbericht: BrLangWetterbericht;
}
